/**
 * Generato automaticamente.
 * framework-cmp-domande
 */

export type GetFrontNotifichePriorita =
  (typeof GetFrontNotifichePriorita)[keyof typeof GetFrontNotifichePriorita];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetFrontNotifichePriorita = {
  BASSA: 'BASSA',
  NORMALE: 'NORMALE',
  ALTA: 'ALTA',
  URGENTE: 'URGENTE',
} as const;
